import { css } from '@emotion/react';
import { color, spacing, typography } from '@uniquegood/realworld-studio-design';

import ConnectCard from '../components/ConnectCard';

/**
 * expired state.
 *
 * authCode가 만료되었거나 이미 사용된 상태.
 * 재시도 액션 없이 안내 메시지만 제공한다 (학교 측에서 재발급 필요).
 *
 * 디자인 톤: yellow tint (informational warning).
 * - yellow = 경고 (회복 가능: 학교에서 재발급 가능)
 * - red = 오류 (실패: ErrorState 에서 사용)
 */
export default function ExpiredState() {
  return (
    <ConnectCard eyebrow="Realworld School" title="연결 코드가 만료되었어요">
      <div css={styles.body} data-testid="connect-state-expired">
        <div css={styles.iconWrap} aria-hidden="true">
          <span css={styles.iconCircle}>!</span>
        </div>
        <p css={styles.description}>
          연결 코드의 사용 시간이 지났어요.
          <br />
          Realworld School에서 다시 시작해 주세요.
        </p>
      </div>
    </ConnectCard>
  );
}

const styles = {
  body: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing.common.medium};
    text-align: center;
  `,
  iconWrap: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  iconCircle: css`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${color.palette_secondary_yellow_tint_04};
    color: ${color.palette_secondary_yellow_100};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: ${typography.weight.bold};
    line-height: 1;
  `,
  description: css`
    margin: 0;
    color: ${color.text_default};
    font-size: ${typography.size.s2};
    line-height: 1.5;
  `
};
